import { ColorIndex1 } from './colorIndex';
import * as THREE from 'three';

function getClosestColorIndex(color) {
  let hexColor;

  if (typeof color === 'string') {
    hexColor = color;
  } else if (typeof color === 'number') {
    // Handle numeric color values (e.g., 0xff0000)
    hexColor = '#' + new THREE.Color(color).getHexString();
  } else if (color && typeof color.getHexString === 'function') {
    // Handle THREE.Color objects
    hexColor = '#' + color.getHexString();
  } else {
    // Default to ByLayer for unknown formats
    return 256;
  }

  const colorList = [];
  for (let i = 0; i < 256; i++) {
    colorList.push(ColorIndex1(i).trim());
  }

  if (!hexColor) return 256; // Default to ByLayer

  const target = hexToRgb(hexColor.toLowerCase());
  if (!target) return 256;

  let closestIndex = 256;
  let minDistance = Infinity;

  for (let i = 0; i < colorList.length; i++) {
    const currentHex = colorList[i];
    const currentRgb = hexToRgb(currentHex);
    if (currentRgb) {
      const distance = colorDistance(target, currentRgb);
      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = i;
      }
    }
  }

  // If the closest match is perfect, return it.
  // Otherwise, you could have a threshold. For now, we return the closest.
  return closestIndex;
}

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

function colorDistance(rgb1, rgb2) {
  const dr = rgb1.r - rgb2.r;
  const dg = rgb1.g - rgb2.g;
  const db = rgb1.b - rgb2.b;
  return Math.sqrt(dr * dr + dg * dg + db * db);
}

export { getClosestColorIndex }; 